import { render, staticRenderFns } from "./AsStampHistoryStatus.vue?vue&type=template&id=669f2fea&scoped=true"
import script from "./AsStampHistoryStatus.vue?vue&type=script&lang=js"
export * from "./AsStampHistoryStatus.vue?vue&type=script&lang=js"
import style0 from "./AsStampHistoryStatus.vue?vue&type=style&index=0&id=669f2fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f2fea",
  null
  
)

export default component.exports